module.exports = __webpack_public_path__ + "static/not-found-illustration-4addef171956e9090c86a1533204b9ad.svg";